import { maintenanceUrl } from "../../config";

let interval = undefined;
let setter = undefined;

const isUnderMaintenance = async () => {
    try {
        const resp = await fetch(maintenanceUrl);
        const { maintenance } = await resp.json();
        if (maintenance === true) {
          return maintenance;
        }
    } catch (err) {

    }
    return false;
}

export const MaintenancePolling = {
    start: async (setMaintenanceMode, retryRateInMs: Number = 60000) => {
        setter = setMaintenanceMode;
        setter(await isUnderMaintenance());
        if (!interval) {
            interval = setInterval(async () => MaintenancePolling.retry(), retryRateInMs);
        }
    },
    retry: async () => {
        setter(await isUnderMaintenance());
    },
    stop: () => {
        if (interval) {
            clearInterval(interval);
            interval = undefined;
        }
    }
}
